import { ReduxThunkAction } from '../../../../redux/redux-actions';
import { reduceAndSubmitClaim } from '../../../../claim/actions/reduce-and-submit-claim';
import { AddRecordCollectionAction } from '../../../../redux/collection-reducer';
import { ADD_RA_DEATH_DECISION } from './types';
import { DecisionModel, Recommendation, Decision } from '../ra-death-assessment-details-reducer';
import { Dependant } from '../../../synopsis/ra-death/dependants/reducer';

type SubmitReturn = Promise<any>;
export type AddAndSubmitAssessmentDependentRecord = (
    decision: any,
    dependant: Dependant
) => SubmitReturn;
type AddAndSubmitAssessmentDecisionRecordThunk = (
    decision: DecisionModel,
    dependant: Dependant
) => ReduxThunkAction<SubmitReturn>;

export const addAndSubmitAssessmentDependantRecordThunk: AddAndSubmitAssessmentDecisionRecordThunk = (
    decision: DecisionModel,
    dependant: Dependant
) => (dispatch, getState) =>
    reduceAndSubmitClaim(
        dispatch,
        getState,
        addAssessmentDecisionActionCreator(decision, dependant)
    );

export type AddAssessmentDecisionRecordAction = AddRecordCollectionAction<Decision>;

export const addAssessmentDecisionActionCreator = (
    decision: DecisionModel,
    dependant: Dependant
): AddAssessmentDecisionRecordAction => {
    const recommendations: Recommendation[] = [];
    const percentageSplits: Recommendation[] = [];

    decision.percentageSplits.forEach(recommendation => {
        recommendations.push({
            dependantId: dependant.id,
            reason: 'none',
            reasonDescription: dependant.relationshipDescription,
            allocation: recommendation.allocation || 0,
        });
    });

    const assessmentDecision: Decision = {
        ...decision,
        recommendations: recommendations,
        percentageSplits: percentageSplits,
    };
    return {
        type: ADD_RA_DEATH_DECISION,
        record: assessmentDecision,
    };
};
